import { Box, Container, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { fontSizeTheme, fontSizeThemeTitle } from "../../theme/ThemeFontSize";

export default function PrivacyPoliticsWally() {
	useEffect(() => {
		const originalTitle = document.title;
		document.title = "Wally - Políticas de Privacidad";

		const favicon = document.querySelector('link[rel="icon"]');
		const originalFavicon = favicon.href;
		favicon.href = "/favicon_9.ico";

		return () => {
			document.title = originalTitle;
			favicon.href = originalFavicon;
		};
	}, []);

	return (
		<Box
			minHeight="70vh"
			sx={{
				position: "relative",
				display: "flex",
				flexDirection: "row",
				px: 1,
				py: 4,
			}}>
			<Container maxWidth="md">
				<Container
					sx={{
						position: "relative",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						px: 1,
						py: 4,
					}}>
					<Box sx={{ mb: 3 }}>
						<img
							src="/images/logo/logo_wally.png"
							alt="Logo de Wally"
							style={{ maxWidth: "100px", height: "auto" }}
						/>
					</Box>
				</Container>
				<Typography
					fontSize={fontSizeThemeTitle}
					sx={{ pb: 1 }}
					variant="h6"
					color="#042D74"
					fontWeight={800}
					align="center"
					gutterBottom>
					Wally
				</Typography>
				<Typography
					fontSize={fontSizeThemeTitle}
					sx={{ pb: 1 }}
					variant="h5"
					color="#042D74"
					fontWeight={600}
					align="center"
					gutterBottom>
					Políticas de Privacidad
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>Fecha de entrada en vigencia:</strong> 12 de junio de 2025
					<br />
					<strong>Última actualización:</strong> 12 de junio de 2025
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>1. Identificación del Responsable del Tratamiento</strong>
					<br />
					ITC – Intelcon Group
					<br />
					Correo electrónico de contacto:{" "}
					<a href="mailto:soporte@intelcongroup.com">soporte@intelcongroup.com</a>
					<br />
					Ámbito de operación: República del Perú
					<br />
					<br />
					La presente Política de Privacidad rige el uso de la aplicación móvil
					Wally (en adelante, "la Aplicación"), de conformidad con la Ley N°
					29733 – Ley de Protección de Datos Personales del Perú y su Reglamento
					aprobado por Decreto Supremo N° 003-2013-JUS.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>2. Acceso a la Aplicación</strong>
					<br />
					La Aplicación es de uso exclusivo para usuarios autorizados por ITC.
					No existe registro público ni autogestión de cuentas. El acceso se
					otorga únicamente mediante credenciales (correo electrónico y
					contraseña) provistas por el administrador del sistema. Los usuarios no
					pueden crear, modificar ni eliminar su propia cuenta a través de la
					Aplicación.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>3. Datos Personales que Recopilamos</strong>
					<br />
					<ul>
						<li>
							<strong>Correo electrónico</strong> — Autenticación y comunicación
							con el usuario
						</li>
						<li>
							<strong>Contraseña (almacenada de forma encriptada)</strong> —
							Control de acceso al sistema
						</li>
						<li>
							<strong>Token de dispositivo (Firebase Cloud Messaging)</strong> —
							Envío de notificaciones push
						</li>
						<li>
							<strong>
								Datos técnicos del dispositivo (modelo, sistema operativo)
							</strong>{" "}
							— Funcionamiento del servicio de notificaciones
						</li>
					</ul>
					La Aplicación no recopila datos biométricos, documentos de identidad,
					datos bancarios ni información de contactos del dispositivo.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>4. Datos de Ubicación</strong>
					<br />
					La Aplicación recibe y muestra coordenadas GPS de los vehículos de la
					flota desde el servidor de la plataforma. Estos datos corresponden a
					los vehículos monitoreados, no a la ubicación del dispositivo móvil del
					usuario. La Aplicación no solicita ni accede al GPS del dispositivo del
					usuario.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>5. Permisos del Dispositivo</strong>
					<br />
					<ul>
						<li>
							<strong>Internet</strong> — Conexión con los servidores de la
							plataforma
						</li>
						<li>
							<strong>Notificaciones push (Android 13+)</strong> — Recepción de
							alertas operativas del sistema
						</li>
						<li>
							<strong>Arranque automático (RECEIVE_BOOT_COMPLETED)</strong> —
							Reactivación del servicio de notificaciones tras reinicio
						</li>
					</ul>
					La Aplicación no solicita acceso a cámara, micrófono, contactos,
					galería ni ubicación del dispositivo.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>6. Finalidad del Tratamiento de Datos</strong>
					<br />
					Los datos recopilados se utilizan exclusivamente para:
					<ul>
						<li>Autenticar el acceso del usuario a la plataforma.</li>
						<li>
							Enviar notificaciones operativas relacionadas con la gestión de
							flota.
						</li>
						<li>Garantizar el correcto funcionamiento de la Aplicación.</li>
					</ul>
					Los datos no se utilizan para publicidad, perfilamiento comercial,
					análisis de mercado ni ninguna finalidad distinta a la operación del
					sistema.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>7. Almacenamiento y Seguridad</strong>
					<br />
					Las credenciales del usuario se almacenan de forma encriptada en el
					dispositivo mediante los mecanismos de seguridad nativos del sistema
					operativo (Android Keystore / iOS Keychain). La comunicación entre la
					Aplicación y los servidores se realiza mediante protocolos seguros
					(HTTPS/WSS). La Aplicación mantiene adicionalmente una base de datos
					local cifrada para el funcionamiento sin conexión.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>8. Servicios de Terceros</strong>
					<br />
					La Aplicación utiliza los siguientes servicios externos:
					<ul>
						<li>
							<strong>Firebase Cloud Messaging (FCM)</strong> — Google LLC —
							Envío de notificaciones push
						</li>
						<li>
							<strong>Google Fonts</strong> — Google LLC — Carga de tipografías
							para la interfaz
						</li>
					</ul>
					Estos proveedores pueden recibir datos técnicos del dispositivo (token
					de notificación, dirección IP) en el marco de la prestación de sus
					servicios. ITC no comparte datos personales de los usuarios con terceros
					con fines comerciales ni de ninguna otra índole.
					<br />
					<br />
					Puede consultar la política de privacidad de Google en:{" "}
					<a
						href="https://policies.google.com/privacy"
						target="_blank"
						rel="noopener noreferrer">
						https://policies.google.com/privacy
					</a>
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>9. Transferencia Internacional de Datos</strong>
					<br />
					Firebase Cloud Messaging y Google Fonts son servicios operados por
					Google LLC, con servidores ubicados fuera del Perú. La transferencia de
					datos técnicos hacia dichos servidores se realiza con base en las
					salvaguardas contractuales y certificaciones de seguridad de Google, en
					cumplimiento del artículo 15° de la Ley N° 29733.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>10. Retención de Datos</strong>
					<br />
					Los datos del usuario se conservan mientras la cuenta esté activa en el
					sistema. La gestión del ciclo de vida de las cuentas es realizada
					íntegramente por el administrador de ITC. Ante cualquier solicitud de
					eliminación o modificación de datos, el usuario deberá dirigirse a:{" "}
					<a href="mailto:soporte@intelcongroup.com">soporte@intelcongroup.com</a>
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>11. Derechos del Titular</strong>
					<br />
					De conformidad con la Ley N° 29733, el usuario tiene derecho a:
					<ul>
						<li>
							<strong>Acceso:</strong> Conocer qué datos personales se tienen
							registrados.
						</li>
						<li>
							<strong>Rectificación:</strong> Solicitar la corrección de datos
							inexactos.
						</li>
						<li>
							<strong>Cancelación:</strong> Solicitar la eliminación de sus datos.
						</li>
						<li>
							<strong>Oposición:</strong> Oponerse al tratamiento de sus datos en
							los casos previstos por ley.
						</li>
					</ul>
					Para ejercer cualquiera de estos derechos, el usuario deberá
					comunicarse a:{" "}
					<a href="mailto:soporte@intelcongroup.com">soporte@intelcongroup.com</a>
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>12. Menores de Edad</strong>
					<br />
					La Aplicación está destinada exclusivamente a uso empresarial. No está
					dirigida a menores de 18 años y no recopila conscientemente datos de
					menores. En caso de detectarse el acceso de un menor, la cuenta será
					desactivada de inmediato por el administrador del sistema.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>13. Modificaciones a esta Política</strong>
					<br />
					ITC se reserva el derecho de actualizar esta Política de Privacidad
					cuando sea necesario. Los cambios serán notificados a los usuarios
					mediante la Aplicación o por correo electrónico. El uso continuado de
					la Aplicación tras la publicación de cambios implica la aceptación de
					la política actualizada.
				</Typography>

				<Typography
					display="block"
					fontSize={fontSizeTheme}
					variant="body1"
					color="text.secondary"
					fontWeight={500}
					align="justify"
					gutterBottom
					style={{ lineHeight: "30px" }}>
					<strong>14. Contacto</strong>
					<br />
					Para consultas, solicitudes o reclamos relacionados con el tratamiento
					de datos personales:
					<br />
					ITC – Intelcon Group
					<br />
					<a href="mailto:soporte@intelcongroup.com">soporte@intelcongroup.com</a>
				</Typography>
			</Container>
		</Box>
	);
}
